export const defaultOnServeHandler = (onServe, teamNumber) => onServe === teamNumber;
export const baseBallOnServeHandler = (onServe, teamNumber) => onServe ? onServe !== teamNumber : false;
export const footballOnServeHandler = (onServe, teamNumber) => onServe ? onServe.includes(`T${teamNumber}`) : false;
//# sourceMappingURL=onServeHandler.js.map